import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArticleSkeleton } from 'common/ui/skeleton-ui';
import SectionTab from 'constants/SectionTab';
import ListItemGrid from 'modules3/components/ListItemGrid';
import NoData from 'modules3/components/no-data';
// import { ShowMore } from 'modules2/components';
import container from './PopularCard.container';

const useStyles = makeStyles((theme) => ({
  articleContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 10
  },
  emptytext: {
    textAlign: 'center',
    width: '100%',
    position: 'relative',
    paddingBottom: theme.spacing(1),
    fontFamily: theme.typography.fontFamily,
    textTransform: 'capitalize'
  }
}));

const PopularCard = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const {
    podcastState: { loading, mostPopular, genresPodcasts },
    userHistoryPodcastState: { heartedPodcastIds },
    onSetCurrentTab,
    onViewPodCastStart,
    onFetchPodCastEpisode,
    onFetchApplePodcastEpisode,
    onFetchListenNotesPodcastEpisode,
    onFavouritePodcast,
    onRemovePodcastHeartStart,
    onShowSnackbarNotification,
    onSetCurrentViewdPodPlaylist
  } = props;

  const onListItemClick = (tab, uuid) => {
    onSetCurrentTab(tab);
    onViewPodCastStart(uuid);
    onFetchPodCastEpisode(uuid);
    onSetCurrentViewdPodPlaylist(uuid);
    /*const id = uuid.toString();
        if (id.length < 15 && id.startsWith('p')) {
            onFetchPodCastEpisode(uuid);
        } else if (id.length <= 15) {
            onFetchApplePodcastEpisode(uuid);
        } else {
            onFetchListenNotesPodcastEpisode(uuid); // for listennotes api episode request
        }*/
  };

  const onFavouriteClick = (id) => {
    const index = heartedPodcastIds.indexOf(id);
    if (index === -1) {
      onShowSnackbarNotification(`Podcast Hearted ❤️`);
      onFavouritePodcast(id);
    } else {
      onShowSnackbarNotification(`Podcast deleted from favorite 😢`);
      onRemovePodcastHeartStart(id);
    }
  };

  const nextItem = () => {};

  const displayList = (loading) => {
    if (loading) {
      return [...Array(matchesXS ? 3 : 6)].map((_, idx) => {
        return <ArticleSkeleton key={idx} />;
      });
    }

    return mostPopular.length ? 
      mostPopular.map((id, index) => {
        return (
          <ListItemGrid
            key={id}
            sectionTab={SectionTab.PodCastDetail}
            podcastid={genresPodcasts[id].id}
            image={
              genresPodcasts[id].image ??
              genresPodcasts[id].artworkUrl100 ??
              'null'
            }
            title={genresPodcasts[id].title ?? genresPodcasts[id].name}
            subtitle={
              genresPodcasts[id].country ??
              genresPodcasts[id].releaseDate ??
              genresPodcasts[id].language
            }
            data={genresPodcasts[id]}
            onListItemClick={onListItemClick}
            onFavouriteClick={onFavouriteClick}
          />
        );
      }
    ) : (
      <div className={classes.emptytext}>
        Most popular podcast not found.
      </div>
    )
  };

  return (
    <>
      <div className={classes.articleContainer}>{displayList(loading)}</div>
      {/*<ShowMore nextRadioList={nextItem}/>*/}
    </>
  );
};

export default container(PopularCard);
